// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tikzjax-content svg {
    overflow: visible;
}

.tikzjax-scaled-content svg {
    width: 100%;
    height: 100%;
    overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./css/container.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".tikzjax-content svg {\n    overflow: visible;\n}\n\n.tikzjax-scaled-content svg {\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
